<div class="">
    <div class="wraper-main-section mb-3">
        <div class="global-card-section_1">
            <form [formGroup]="liveSettingForm">
                <div class="">
                    <div class="">
                        <div class="global-body-section">
                            <div class="flex-row-inner">
                                <div class="wraper-body-left">
                                    <div class="custom-action-title" style="height: 44px;">
                                        <span>Inbound Email Box: Suppression List</span>
                                        <div class="button-wrapper flex-row-inner">
                                            <button type="button" [hidden]="isShowViewMode" matTooltip="Save" class="icon-btn" (click)="liveConnectSave()">
                                                <i class="fa fa-save" aria-hidden="true"></i>
                                                <span class="btn-text">Save</span>
                                            </button>
                                            <button type="button" [hidden]="isShowViewMode" (click)="showViewMode()" matTooltip="Cancel" class="icon-btn">
                                                <i class="fa fa-angle-double-left" aria-hidden="true"></i>
                                                <span class="btn-text">Cancel</span>
                                            </button>

                                            <button type="button" *ngIf="isShowViewMode && isShowButtons" matTooltip="Edit" class="icon-btn" (click)="showViewMode()">
                                                <i class="fa fa-pencil-alt" aria-hidden="true"></i>
                                                <span class="btn-text">Edit</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="flex-width-panel">
                                        <div class="cards-colunm-left">
                                            <div class="align-center">
                                                <span class="control-label spantext">Inbox Email Address</span>
                                            </div>
                                        </div>
                                        <div class="cards-colunm-right">
                                            <span>{{emailBox?.inboxAddress}}</span>
                                        </div>
                                    </div>
                                    <div class="flex-width-panel">
                                        <div class="cards-colunm-left">
                                            <div class="align-center">
                                                <span class="control-label spantext"></span>
                                            </div>
                                        </div>
                                        <div class="cards-colunm-right">
                                            <div class="common-mat-grid full-width-container">
                                                <!--grid goes here-->
                                                <table mat-table [dataSource]="suppressionSource" class="mat-elevation-z8" matSort>
                                                    <ng-container *ngFor="let column of columns" [matColumnDef]="column.field">
                                                        <th mat-header-cell *matHeaderCellDef>
                                                            <div class="customer-name" *ngIf="column.field == 'emails'">
                                                                {{column.title}}<br />
                                                                <a *ngIf="!isShowViewMode" (click)="clearAllEmail()">Clear All</a>
                                                            </div>
                                                            <div class="customer-name" *ngIf="column.field == 'domains'">
                                                                {{column.title}}<br />
                                                                <a *ngIf="!isShowViewMode" (click)="clearAllDomain()">Clear All</a>
                                                            </div>
                                                        </th>
                                                        <td mat-cell *matCellDef="let dataItem; let rowIndex = index">
                                                            <div  *ngIf="column.field == 'emails'">
                                                                <div class="flex-align-panel" style="flex-wrap:wrap" *ngFor="let item of dataItem[column.field]">
                                                                    <button *ngIf="!isShowViewMode" class="grid-delete-btn" type="button" matTooltip="Delete" (click)="emailBoxSuppress_Remove(item?.emailBoxSuppressID)">
                                                                        <img src="../../../assets/trash-btn.svg" />
                                                                    </button>
                                                                    <span class="margin-left10"> {{item?.val}}</span>
                                                                </div>
                                                            </div>
                                                            <div  *ngIf="column.field == 'domains'">
                                                                <div class="flex-align-panel" style="flex-wrap:wrap" *ngFor="let item of dataItem[column.field]">
                                                                    <button *ngIf="!isShowViewMode" class="grid-delete-btn" type="button" matTooltip="Delete" (click)="emailBoxSuppress_Remove(item?.emailBoxSuppressID)">
                                                                        <img src="../../../assets/trash-btn.svg" />
                                                                    </button>
                                                                    <span class="margin-left10">{{item?.val}}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </ng-container>
                                                    <tr mat-header-row *matHeaderRowDef="suppressionDisplayColumns"></tr>
                                                    <tr mat-row *matRowDef="let row; columns: suppressionDisplayColumns;"></tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

